module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "is-relative"
  }, [_c('h3', {
    staticClass: "stepper__content__header"
  }, [_vm._v(_vm._s(_vm.$t('WHERE_DID_YOU_GET_BRASTER_FROM')))]), _vm._v(" "), _c('div', {
    staticClass: "content__wrapper flex-center"
  }, [_c('div', {
    staticClass: "header--description box-shadow box-shadow--arrow-left"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('IF_YOU_BOUGHT_FOR_YOURSELF')) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex-center flex-row"
  }, [_c('label', {
    staticClass: "fake-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s1q1Val),
      expression: "s1q1Val"
    }],
    staticClass: "custom-input",
    attrs: {
      "type": "radio",
      "value": "true",
      "name": "s1q1Val"
    },
    domProps: {
      "checked": _vm._q(_vm.s1q1Val, "true")
    },
    on: {
      "change": function($event) {
        _vm.s1q1Val = "true"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-container"
  }, [_vm._v(_vm._s(_vm.$t('BOUGHT')))]), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('label', {
    staticClass: "fake-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s1q1Val),
      expression: "s1q1Val"
    }],
    staticClass: "custom-input",
    attrs: {
      "type": "radio",
      "value": "other",
      "name": "s1q1Val"
    },
    domProps: {
      "checked": _vm._q(_vm.s1q1Val, "other")
    },
    on: {
      "click": _vm.goNext,
      "change": function($event) {
        _vm.s1q1Val = "other"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-container"
  }, [_vm._v(_vm._s(_vm.$t('GOT')))]), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('label', {
    staticClass: "fake-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s1q1Val),
      expression: "s1q1Val"
    }],
    staticClass: "custom-input",
    attrs: {
      "type": "radio",
      "value": "false",
      "name": "s1q1Val"
    },
    domProps: {
      "checked": _vm._q(_vm.s1q1Val, "false")
    },
    on: {
      "click": _vm.goNext,
      "change": function($event) {
        _vm.s1q1Val = "false"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-container"
  }, [_vm._v(_vm._s(_vm.$t('REALIZE_EXAMINATION_0')))]), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), (_vm.s1q1Val === 'true') ? _c('div', {
    staticClass: "flex-center flex-row mt-3"
  }, [_c('label', {
    staticClass: "fake-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s1q1ValAdditional),
      expression: "s1q1ValAdditional"
    }],
    staticClass: "custom-input",
    attrs: {
      "type": "radio",
      "value": "true",
      "name": "s1q1Val"
    },
    domProps: {
      "checked": _vm._q(_vm.s1q1ValAdditional, "true")
    },
    on: {
      "click": _vm.goNext,
      "change": function($event) {
        _vm.s1q1ValAdditional = "true"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-container"
  }, [_vm._v(_vm._s(_vm.$t('JUST_FOR_ME')))]), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('label', {
    staticClass: "fake-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s1q1ValAdditional),
      expression: "s1q1ValAdditional"
    }],
    staticClass: "custom-input",
    attrs: {
      "type": "radio",
      "value": "other",
      "name": "s1q1Val"
    },
    domProps: {
      "checked": _vm._q(_vm.s1q1ValAdditional, "other")
    },
    on: {
      "click": _vm.goNext,
      "change": function($event) {
        _vm.s1q1ValAdditional = "other"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-container"
  }, [_vm._v(_vm._s(_vm.$t('FOR_ME_AND_WOMAN')))]), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('label', {
    staticClass: "fake-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.s1q1ValAdditional),
      expression: "s1q1ValAdditional"
    }],
    staticClass: "custom-input",
    attrs: {
      "type": "radio",
      "value": "false",
      "name": "s1q1Val"
    },
    domProps: {
      "checked": _vm._q(_vm.s1q1ValAdditional, "false")
    },
    on: {
      "click": _vm.buyForWomen,
      "change": function($event) {
        _vm.s1q1ValAdditional = "false"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-container"
  }, [_vm._v(_vm._s(_vm.$t('FOR_WOMAN')))]), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d79891e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/main-survey/survey-step1-q1.vue
// module id = 1222
// module chunks = 0